import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {Button, Checkbox, CheckboxProps, FormTextArea, Header, Loader, Message, Modal} from 'semantic-ui-react';
import {TaskThunk} from '../../../../../store/thunk/task.thunk';
import TaskModel from '../../../../../models/responses/task.model';
import "react-datepicker/dist/react-datepicker.css";
import {useActiveProjectSelector} from "../../../../../store/selectors/project.selectors";
import EventTextModel from "../../../../../models/event-text-model.enum";

interface PropsModel {
    sliderValue: number,
    task: TaskModel,
    setShowModal: (val: boolean) => void,
    setProgressChanged: (val: boolean) => void
    setSliderValue: (val: number) => void
    setShowEventModal: (val: boolean) => void
    setModalMessage: (val: EventTextModel) => void
}

export default function TaskProgressModal (props: PropsModel) {
    const {sliderValue, task, setProgressChanged, setModalMessage, setShowEventModal } = props;
    const [reason, setReason] = useState<any>('');
    const [finalValue, setFinalValue] = useState<number>(sliderValue);
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false);
    const activeProject = useActiveProjectSelector();

    const handleSubmit = () => {
        setSubmitButtonDisabled(true);
        TaskThunk.updateTaskProgress(task, sliderValue, reason, activeProject?.snapshotDataVersionId ? activeProject.snapshotDataVersionId : null)
            .then(() => {
                setProgressChanged(false)
                props.setShowModal(false)
                props.setSliderValue(finalValue)
                setSubmitButtonDisabled(false);
                if (sliderValue === 100) {
                    setModalMessage(EventTextModel.COMPLETE_TASK)
                    setShowEventModal(true);
                }

            })
            .catch((e) => console.error(e));
    }

    const handleClose = () => {
        props.setShowModal(false)
        setProgressChanged(false)
        if (!task.progress) {
            props.setSliderValue(0)
        } else {
            props.setSliderValue(task.progress.sort((a, b) => b.date.seconds - a.date.seconds)[0].progress)
        }
    }

    const handleSliderChange = (e: any) => {
        setFinalValue(e.target.value)
        props.setSliderValue(e.target.value)
    }

    return (
        <>
            <Modal dimmer='blurring' className="modal-event" open={true} closeIcon onClose={() => handleClose()}>
                <Header textAlign="center" content={"Task progress entry"} />
                <div style={{
                    display: 'flex',
                    flexDirection: 'column', margin: "auto", padding: "10px", alignItems: "center"
                }}>
                    <h5>{`${task.task_code} - ${task.task_name}`}</h5>
                    {task.wbsPath && <p>{`(${task.wbsPath}) / ${task.wbs})`}</p>}
                    <h4 style={{marginTop: "5px"}}>{`You are progressing ${task.task_code} to ${sliderValue}% complete. Please add a comment and confirm.`}</h4>
                    <span><input type={'number'} onChange={handleSliderChange} value={finalValue} style={{width: "50px"}}/>% complete</span>
                </div>
                <FormTextArea placeholder={'Add comment...'}
                              style={{margin: 'auto', width: '310px', borderColor: '#bfbfbf'}}
                              value={reason !== '' ? reason : undefined}
                              onChange={(e, {value}) => setReason(value)}
                />
                <Modal.Actions>
                    <Button
                        onClick={() => handleClose()}
                        negative>
                        Cancel
                    </Button>
                    {submitButtonDisabled ? <Button
                        onClick={() => {}}
                        disabled
                        positive>
                            <Loader size='mini' active inline />
                    </Button> :
                    <Button
                        onClick={() => handleSubmit()}
                        positive>
                        Submit
                    </Button>}
                </Modal.Actions>
            </Modal>

        </>
    )
}
